import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from 'features/core/shared/service/crud/mvs-crud-mode.enum';

/**
* Thin CRUD service for cn.CommissionDecisionSnapshot.
* Used by CnDecisionSnapshotComponent to load the immutable decision aggregate (FR-13).
*/
@Injectable({
    providedIn: 'root'
})
export class CommissionDecisionSnapshotService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cn/commissionDecisionSnapshots');
    }

    getObjectIcon(): string {
        return 'fa-solid fa-file-shield';
    }

    /**
     * Human-readable entity labels [singular, plural].
     * Element [0] is the singular label consumed by the core CRUD dialog title
     * (MvsCoreService.getObjectLabels(objectType)?.[0]) so the create/edit dialog
     * shows "Entscheidungs-Snapshot anlegen" / "Entscheidungs-Snapshot bearbeiten"
     * instead of the literal field name. These are entity labels, NOT field names.
     */
    getObjectLabels(): string[] {
        return ['Entscheidungs-Snapshot', 'Entscheidungs-Snapshots'];
    }

    /**
    * No dedicated object component for the immutable decision snapshot — detail/edit
    * mode falls back to the metadata-driven generic form (returns null).
    */
    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

}
